/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_2_Task_Deep_Focus_OnceInputs */

const en_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 1 Deep Focus`)
};

const ar_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل تركيزًا عميقًا واحدًا`)
};

const de_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Deep Focus abschließen`)
};

const es_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 1 concentración profunda`)
};

const fr_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer 1 session de Concentration Profonde`)
};

const it_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 1 Concentrazione intensiva`)
};

const ja_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディープフォーカスを1回完了`)
};

const ko_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초집중 1회 완료하기`)
};

const pt_br_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua 1 Foco Total`)
};

const ru_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершить 1 глубокую фокусировку`)
};

const th_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสเต็มที่ให้เสร็จสิ้น 1 ครั้ง`)
};

const tr_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Derin Odaklanmayı Tamamla`)
};

const zh_cn_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 1 次深度专注`)
};

const zh_tw_phase_2_task_deep_focus_once = /** @type {(inputs: Phase_2_Task_Deep_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 1 次深度專注`)
};

/**
* | output |
* | --- |
* | "Complete 1 Deep Focus" |
*
* @param {Phase_2_Task_Deep_Focus_OnceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_2_task_deep_focus_once = /** @type {((inputs?: Phase_2_Task_Deep_Focus_OnceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_2_Task_Deep_Focus_OnceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_2_task_deep_focus_once(inputs)
	if (locale === "ar") return ar_phase_2_task_deep_focus_once(inputs)
	if (locale === "de") return de_phase_2_task_deep_focus_once(inputs)
	if (locale === "es") return es_phase_2_task_deep_focus_once(inputs)
	if (locale === "fr") return fr_phase_2_task_deep_focus_once(inputs)
	if (locale === "it") return it_phase_2_task_deep_focus_once(inputs)
	if (locale === "ja") return ja_phase_2_task_deep_focus_once(inputs)
	if (locale === "ko") return ko_phase_2_task_deep_focus_once(inputs)
	if (locale === "pt_br") return pt_br_phase_2_task_deep_focus_once(inputs)
	if (locale === "ru") return ru_phase_2_task_deep_focus_once(inputs)
	if (locale === "th") return th_phase_2_task_deep_focus_once(inputs)
	if (locale === "tr") return tr_phase_2_task_deep_focus_once(inputs)
	if (locale === "zh_cn") return zh_cn_phase_2_task_deep_focus_once(inputs)
	return zh_tw_phase_2_task_deep_focus_once(inputs)
});